export default __webpack_public_path__ + "static/media/330_store04-it-web.78fec573.png";